import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <span className="footer__dot"></span>
    </footer>
  )
}

export default Footer